import React from 'react';

const Spinner = ({ text = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen mt-20">
      <div 
        className={
          `w-48 h-48 border-8 border-t-8 border-transparent rounded-full animate-spin border-[#FF4E8E]`
        }
        style={{ borderTopColor: '#FF4E8E' }}
      ></div>
      <p className="mt-10 text-2xl font-semibold" style={{ color: 'rgba(255,255,255,0.9)' }}>{text}</p>
    </div>
  );
};

export default Spinner;
